class SlideShow extends lm.Composant {
  /**
   * @constructor
   * @param {String} id
   */
  constructor(id) {
    super(id);
  }
}
function initSlideshow() {
  new SlideShow('slideshow');
}
if (document.readyState === 'loading') {
  globalThis.addEventListener('DOMContentLoaded', initSlideshow);
} else {
  initSlideshow();
}